import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import './ZoomImage.css';

const isMobile = () =>
  typeof window !== "undefined" &&
  (window.innerWidth <= 768 ||
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));

const ZoomImage = ({ src, zoomScale = 2 }) => {
  const [backgroundPosition, setBackgroundPosition] = useState('0% 0%');
  const [isZoomVisible, setZoomVisible] = useState(false);
  const [zoomBoxPos, setZoomBoxPos] = useState({ top: 0, left: 0, width: 0, height: 0 });
  const imgRef = useRef(null);

  // For mobile: open zoom as popup on click/tap, close on second tap
  const handleImageClick = (e) => {
    if (!isZoomVisible) {
      if (isMobile()) {
        setZoomVisible(true);
        setBackgroundPosition('50% 50%');
      } else {
        const { left, top, width, height } = imgRef.current.getBoundingClientRect();
        setZoomBoxPos({
          top,
          left: left + width + 16,
          width,
          height,
        });
        setZoomVisible(true);
        setBackgroundPosition('50% 50%');
      }
    } else {
      setZoomVisible(false);
    }
  };

  // For desktop: open on hover, move with mouse
  const handleMouseMove = (e) => {
    if (isMobile()) return;
    const { left, top, width, height } = imgRef.current.getBoundingClientRect();
    const x = ((e.pageX - left - window.scrollX) / width) * 100;
    const y = ((e.pageY - top - window.scrollY) / height) * 100;
    setBackgroundPosition(`${x}% ${y}%`);
    setZoomBoxPos({
      top,
      left: left + width + 16,
      width: width + 50,
      height,
    });
  };

  const handleMouseEnter = () => {
    if (isMobile()) return;
    setZoomVisible(true);
    const { left, top, width, height } = imgRef.current.getBoundingClientRect();
    setZoomBoxPos({
      top,
      left: left + width + 16,
      width: width + 50,
      height,
    });
  };

  const handleMouseLeave = () => {
    if (isMobile()) return;
    setZoomVisible(false);
  };

  return (
    <>
      <div className="zoom-wrapper">
        <div
          className="zoom-container"
          onMouseMove={handleMouseMove}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleImageClick}
          ref={imgRef}
          style={{ cursor: isMobile() ? 'pointer' : 'zoom-in' }}
        >
          <img src={src} alt="zoom-img" className="main-image" />
        </div>
      </div>
      {isZoomVisible && isMobile() &&
        ReactDOM.createPortal(
          <div
            className="zoom-popup-mobile"
            onClick={() => setZoomVisible(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              background: 'rgba(0,0,0,0.8)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10000,
            }}
          >
            <div
              className="zoom-box-mobile"
              style={{
                width: '90vw',
                height: '70vh',
                backgroundImage: `url(${src})`,
                // backgroundSize: `${zoomScale * 100}%`,
                // backgroundPosition: backgroundPosition,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 16px rgba(0,0,0,0.3)',
              }}
            />
          </div>,
          document.body
        )
      }
      {isZoomVisible && !isMobile() &&
        ReactDOM.createPortal(
          <div
            className="zoom-box"
            style={{
              position: 'absolute',
              top: zoomBoxPos.top,
              left: zoomBoxPos.left,
              width: zoomBoxPos.width,
              height: zoomBoxPos.height,
              backgroundImage: `url(${src})`,
              backgroundSize: `${zoomScale * 100}%`,
              backgroundPosition: backgroundPosition,
              zIndex: 9999,
            }}
          />,
          document.body
        )
      }
    </>
  );
};

export default ZoomImage;